import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import toast from 'react-hot-toast';
import { API_BASE_URL } from '../../config/api';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token =
      (typeof window !== 'undefined' && localStorage.getItem('smartpm_token')) ||
      (getState() as { auth?: { token: string | null } })?.auth?.token;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    headers.set('Content-Type', 'application/json');
    return headers;
  },
});

/** Extract error message from RTK Query error (data.detail, data.message, or status text) */
function getErrorMessage(error: FetchBaseQueryError): string {
  const data = error?.data;
  if (data && typeof data === 'object') {
    if (typeof (data as { detail?: string }).detail === 'string') return (data as { detail: string }).detail;
    if (typeof (data as { message?: string }).message === 'string') return (data as { message: string }).message;
  }
  return error?.status === 401
    ? 'Unauthorized'
    : error?.status === 403
      ? 'Forbidden'
      : error?.status
        ? `Error ${error.status}`
        : 'Request failed';
}

const baseQueryWithToast: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);
  if (result.error) {
    const message = getErrorMessage(result.error);
    toast.error(message);
  }
  return result;
};

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithToast,
  tagTypes: ['Auth'],
  endpoints: () => ({}),
});
